export const MERCHANT_NAME = 'ROOT';
export const APPLE_PAY_VERSION = 3;
